// modules/auth/index.ts
import { ModuleConfig } from '@/core/module';
import { authRoutes } from './routes';

export const AuthModule: ModuleConfig = {
    name: 'auth',
    routes: authRoutes,
    stores: {},
    initialize: () => {
        console.log('Auth module initialized');
    },
    cleanup: () => {
        console.log('Auth module cleaned up');
    }
};
